import React from 'react';
import styled from 'styled-components';
import Text from './styled/Text';
import { StyledTag } from './TagFormatter';

const StyledTagWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export function OrderFormatter({ data }) {
  return (
    <>
      <StyledTagWrapper>
        {data.map(item => (
          <StyledTag key={item}>
            <Text variant="body">{item}</Text>
          </StyledTag>
        ))}
      </StyledTagWrapper>
    </>
  );
}
